export const SchoolInfoTypes = {
  // CLASS BASE LIST
  FETCH_CLASSBASE_START: "FETCH_CLASSBASE_START",
  FETCH_CLASSBASE_SUCCESS: "FETCH_CLASSBASE_SUCCESS",
  FETCH_CLASSBASE_FAILURE: "FETCH_CLASSBASE_FAILURE",
  // CLASS LIST
  FETCH_CLASS_START: "FETCH_CLASS_START",
  FETCH_CLASS_SUCCESS: "FETCH_CLASS_SUCCESS",
  FETCH_CLASS_FAILURE: "FETCH_CLASS_FAILURE",
  // COURSE
  FETCH_COURSE_START: "FETCH_COURSE_START",
  FETCH_COURSE_SUCCESS: "FETCH_COURSE_SUCCESS",
  FETCH_COURSE_FAILURE: "FETCH_COURSE_FAILURE",
  // STUDENT
  FETCH_STUDENT_START: "FETCH_STUDENT_START",
  FETCH_STUDENT_SUCCESS: "FETCH_STUDENT_SUCCESS",
  FETCH_STUDENT_FAILURE: "FETCH_STUDENT_FAILURE",
  EDIT_STUDENT_LIST: "EDIT_STUDENT_LIST",
  ///
  RESET_ERRORS: "RESET_ERRORS",
};
